// Configuration file for API endpoints and other constants
const config = {
  // API endpoints
  FETCH_DOMAIN: 'https://demoapi.aichatassist.com',
  BASE_URL: 'https://api.aichatassist.com',
  EMAIL_OTP: 'https://admin.aichatassist.com',
  SendEmail: 'https://admin.aichatassist.com/api',
  ChatBotDemo: 'https://demo1.aichatassist.com/',
  
  // Other constants
  Recaptcha_KEY: '6LdRApMqAAAAAAQ_-A_gO-0EsKrplHmhvdgEiB6g',
};

export default config;
